import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 8,
    backgroundColor: theme.palette.grey[200],
    margin: '8px 0'
  },
  header: { padding: theme.spacing(2) },
  guestDetails: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(1.5),
    marginBottom: 16,
    backgroundColor: theme.palette.background.default
  },

  roomHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16
  },
  roomDetails: { padding: 16 },
  subSectionTitle: {
    fontWeight: 600,
    margin: '8px 0',
    color: theme.palette.text.primary
  },
  icon: { fontSize: 20, color: theme.palette.text.primary },
  verticalAlign: {
    fontWeight: 500,
    fontSize: '1rem',
    display: 'flex',
    verticalAlign: 'middle',
    lineHeight: '22px',
    color: theme.palette.text.primary
  },
  profileIcon: {
    fontSize: 20,
    color: theme.palette.grey[700],
    marginRight: 4
  },
  greyText: { fontWeight: 600, color: theme.palette.grey[600] },
  blackText: { fontWeight: 500, color: theme.palette.text.primary },

  iconBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    minWidth: 80,
    borderRight: '1px solid #e0e0e0',
    color: '#333'
  },
  iconText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: 6
  },
  personLabel: {
    fontSize: 14,
    fontWeight: 500
  },
  personRole: {
    fontSize: 12,
    color: '#888'
  },
  detailsBox: {
    flexGrow: 1,
    paddingLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    borderLeft: `1px solid ${theme.palette.grey[400]}`
  },
  fullName: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 4,
    color: '#222'
  },
  email: {
    fontSize: 12,
    color: '#666'
  },
  phone: {
    fontSize: 12,
    color: '#666',
    marginLeft: 'auto'
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    padding: 6,
    background: theme.palette.background.default,
    margin: '12px 0px',
    borderRadius: 6,
    border: `1px solid ${theme.palette.grey[300]}`,
    flex: '0 0 auto'
  },
  tableHeader: {
    display: 'grid',
    padding: 4,
    background: theme.palette.grey[200],
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  tableRow: {
    display: 'grid',
    padding: 4,
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  cell: {
    textAlign: 'center',
    color: theme.palette.grey[700],
    fontWeight: 500
  },
  personCard: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(1.5),
    margin: '4px 0',
    backgroundColor: theme.palette.background.default
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 16
  },
  formIcon: {
    color: theme.palette.grey[500],
    fontSize: 18,
    marginRight: 8,
    alignSelf: 'center'
  },
  scrollWrapper: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    display: 'block',
    paddingBottom: theme.spacing(1),

    '&::-webkit-scrollbar': {
      height: 6
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3
    }
  },
  scrollRow: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(2),
      // ensure children don't wrap to a new line
      flexWrap: 'nowrap',
      alignItems: 'stretch'
    }
  }
}))
